<template>
  <div id="dashboard-content">
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
    <div v-else>
      <div class="mb-3">
        <h1 class="h4">Pendaftaran Penilaian Buku</h1>
        <!-- <p class="text-muted">Silakan lanjutkan di dalam iframe berikut.</p> -->
      </div>
      <div class="embed-responsive embed-responsive-16by9 border">
        <iframe
          v-if="iframeSrc"
          :src="iframeSrc"
          class="w-100"
          style="min-height: 75vh; border: 0;"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Penilaian Embed",
  data() {
    return {
      iframeSrc: "",
      error: "",
    };
  },
  methods: {
    initIframe() {
      const { event_type, event_id, book_id, token } = this.$route.query;
      if (!event_type || !event_id || !book_id || !token) {
        this.error = "Parameter tidak lengkap. Pastikan akses dari halaman pendaftaran BTP.";
        return;
      }
      const safeEventType = encodeURIComponent(event_type);
      const safeEventId = encodeURIComponent(event_id);
      const safeBookId = encodeURIComponent(book_id);
      const safeToken = encodeURIComponent(token);
      this.iframeSrc = 
        `https://penilaian-buku.cloudapp.web.id/penerbit/submission/${safeEventType}/${safeEventId}/${safeBookId}?token=${safeToken}`;
    },
  },
  created() {
    this.initIframe();
  },
};
</script>

<style lang="scss" scoped>
#dashboard-content {
  padding-top: 1rem;
}
</style>